import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

import { Referential } from '../models/referential.model';

@Injectable({
  providedIn: 'root'
})
export class ReferentialService {
  private baseUrl: string = environment.apiUrl + '/referential';

  constructor(private http: HttpClient) {}

  public getReferentials(): Observable<Array<Referential>> {
    return this.http.get<Array<Referential>>(this.baseUrl);
  }
}
